import { useState, useCallback } from 'react';

export function useAlertRulesSelection() {
    const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
    const [isMultiSelectMode, setIsMultiSelectMode] = useState(false);

    const selectedCount = selectedIds.size;

    const toggleItem = useCallback((id: string) => {
        setSelectedIds((prev) => {
            const newSet = new Set(prev);
            if (prev.has(id)) {
                newSet.delete(id);
            } else {
                newSet.add(id);
            }
            return newSet;
        });
    }, []);

    const selectAll = useCallback((ids: string[]) => {
        setSelectedIds(new Set(ids));
    }, []);

    const clearSelection = useCallback(() => {
        setSelectedIds(new Set());
    }, []);

    const enterMultiSelectMode = useCallback(() => {
        setIsMultiSelectMode(true);
    }, []);

    const exitMultiSelectMode = useCallback(() => {
        setIsMultiSelectMode(false);
        clearSelection();
    }, [clearSelection]);

    return {
        selectedIds,
        isMultiSelectMode,
        selectedCount,
        toggleItem,
        selectAll,
        clearSelection,
        enterMultiSelectMode,
        exitMultiSelectMode,
    };
}
